import {atom} from "jotai/index";
import {useAtom} from "jotai";
import {AnalysisOptionsDep} from "../../../2-option-selection/AnalysisOptions.ts";
import {errorText} from "../../scan-operations/error/ErrorText.ts";
import {postError} from "./ScanErrorLogger.ts";
import {useRef} from "react";

export interface LogMessage {
    timestamp: Date
    level: string
    message: string
}

const ScanMessagesAtom = atom<LogMessage[]>([])
export type Log = (message: string, level?: string) => void

/**
 * Log an error message. This will output it to the scan log, the console and optionally attempt to upload it to the
 * backend for future tracking.
 */
export type LogError = (message: string, error?: unknown) => unknown

//If the analysis options change, reset the scan data
AnalysisOptionsDep((set) => {
    set(ScanMessagesAtom, [])
})

interface Options {
    reportAnonymisedErrors: boolean
}
export function useScanMessages(options: Options): [LogMessage[], Log, LogError, errors: string[]] {
    const [messages, setMessages] = useAtom(ScanMessagesAtom)
    const errorsRef = useRef<string[]>([])

    function log(message: string, level: string = "INFO") {
        setMessages((old) => [...old, {
            level,
            message,
            timestamp: new Date()
        }])
    }

    async function logError(message: string, error?: unknown) {
        const messageWithPeriod = message.endsWith(".") ? message : `${message}.`
        errorsRef.current.push(`${messageWithPeriod} ${errorText(error)}`)
        log(`${messageWithPeriod} ${errorText(error)}`, "ERROR")
        console.error(messageWithPeriod, error)
        if(options.reportAnonymisedErrors) {
            await postError(message, options, error)
        }
    }

    return [messages, log, logError, errorsRef.current]
}